import React, { useEffect } from "react";
import { useUpdateBussinessType } from "../../../queryHooks";
import { confirmSchema } from "../../../validations";
import CS from "../../../services/commonService";
import { useFormik } from "formik";
import { useStore } from "../../../zustand/store";

//  Component starts
const BusinessTypeModal = ({ restaurantId, onCloseModal }) => {
	//	State values
	const setLoading = useStore((state) => state.setLoading);

	const { values, errors, handleChange, handleSubmit, touched } = useFormik({
		initialValues: {
			confirm: "",
		},
		validationSchema: confirmSchema,
		onSubmit: () =>
			updateBusinessType({
				restaurantId,
				body: { business_type: "FRANCHISE" },
			}),
	});

	const {
		mutateAsync: updateBusinessType,
		error: errorUpdateBusinessType,
		data: dataUpdateBusinessType,
		isLoading: updateBusinessTypeLoading,
	} = useUpdateBussinessType();

	useEffect(() => {
		setLoading(updateBusinessTypeLoading);
	}, [updateBusinessTypeLoading]);

	useEffect(() => {
		if (dataUpdateBusinessType) {
			CS.showSuccessMessage(dataUpdateBusinessType?.message);
			onCloseModal();
		}
	}, [dataUpdateBusinessType]);

	useEffect(() => {
		if (errorUpdateBusinessType) {
			CS.showErrorMessage(errorUpdateBusinessType.response?.data?.message);
		}
	}, [errorUpdateBusinessType]);

	const onClose = () => {
		onCloseModal();
	};

	return (
		<div className="modal-content">
			<div className="modal-header">
				<h5 className="modal-title" style={{ lineHeight: 1.5 }}>
					Are you sure you want to change business type from INDIVIDUAL to
					FRANCHISE ?
				</h5>
			</div>
			<div className="notification-form modal-body card profile-card password-modal">
				<div className="row">
					<div className="col-md-12">
						<div className="mb-md-4 mb-3">
							<div className="form-group mb-0">
								<label className="mb-0">Note :</label>
								<br />
								<div style={{ color: "#475f7b" }}>
									<ul style={{ display: "list-item" }}>
										<li>
											- This change is irreversible i.e, once changed to
											Franchise cannot be changed back to Individual.
										</li>

										<li>
											- This restaurant will be parent restaurant after change
											of business type to franchise.
										</li>
									</ul>
								</div>

								<p style={{ marginTop: "10px", marginBottom: "10px" }}>
									Type <b>confirm</b> to proceed
								</p>
								<input
									title=""
									className="form-control"
									id="confirm"
									name="confirm"
									placeholder={`Enter confirm here`}
									value={values.confirm}
									type="text"
									onChange={handleChange}
								/>

								<span className="text-danger d-block">
									{errors.confirm && touched.confirm ? errors.confirm : null}
								</span>
								{/* <label className="label xl-label" htmlFor="faqCategoryName">
										Category Name<sup className="text-danger">*</sup>
									</label>
									<div className="w-100 position-relative">
										<input
											className="form-control"
											type="text"
											id="name"
											name="name"
											placeholder="Category Name"
											value={values.name}
											onChange={handleChange}
										/>
										<div className="error-message-password">
											<span className="text-danger error-msg d-block mb-2">
												{errors.name && touched.name ? errors.name : null}
											</span>
										</div>
									</div> */}
							</div>
						</div>
						<div className="mt-5 text-right">
							<button
								className="btn"
								type="cancel"
								style={{
									margin: "15px",
									backgroundColor: "#FF5B5C",
									color: "white",
									border: "1px solid",
								}}
								onClick={() => onClose()}
							>
								Cancel
							</button>
							<button
								className="btn btn-primary"
								type="submit"
								onClick={handleSubmit}
							>
								Proceed
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BusinessTypeModal;
